module.exports = __webpack_public_path__ + "img/404-mob-en.9055a98.svg";